export interface BasicAuthData {
  user: string,
  pass: string
}

export enum InternalApi {
  http = 'http',
  edi = 'edi',
  insight = 'insight'
}

export enum CustomerApi {
  'sync_service' = 'sync_service'
}

export enum ShopApi {
  shopify = 'shopify',
  bolcom = 'bolcom',
  mirakl = 'mirakl',
  woocommerce = 'woocommerce',
  magento = 'magento'
}

export enum FinanceApi {
  exact = 'exact',
  msdynamics = 'msdynamics'
}

export enum MessageApi {
  slack = 'slack',
  capptions = 'capptions'
}

export enum AppApi {
  directr = 'directr',
  skaal = 'skaal'
}

export enum DatabaseApi {
  postgres = 'postgres',
  contentful = 'contentful',
  digitalocean = 'digitalocean'
}

export enum PrintApi {
  printnode = 'printnode'
}

export enum ShipmentApi {
  postnl = 'postnl',
  dpd = 'dpd',
  mendrix = 'mendrix',
  rjp = 'rjp',
  packs = 'packs',
  dhl = 'dhl',
  ups = 'ups',
  royalmail = 'royalmail',
  vdh = 'vdh',
  cbhub = 'cbhub',
  sinerlog = 'sinerlog',
  deutschepost = 'deutschepost',
  simpleshipment = 'simpleshipment',
  gls = 'gls',
  mileexpress = 'mileexpress',
  trunkrs = 'trunkrs'
}

export enum PricingApi {
  syscalc = 'syscalc'
}

export enum ServiceGroup {
  Shipment = 'shipment',
  Printer = 'printer',
  Messaging = 'messaging',
  Catalogue = 'catalogue',
  Financial = 'financial',
  Pricing = 'pricing'
}

export enum CtrlService {
  Sys = 'sys', // @Service Sys, generic
  Auth = 'auth', // @Service Auth, connecting to auth
  Ctrl = 'ctrl',
  Master = 'master'
}

export enum CdnService {
  Contentful = 'contentful',
  Digitalocean = 'digitalocean'
}

export default {
  InternalApi,
  CustomerApi,
  ShopApi,
  FinanceApi,
  MessageApi,
  AppApi,
  DatabaseApi,
  PrintApi,
  ShipmentApi,
  PricingApi,
  CdnService,
  CtrlService
}

export type ServiceType = InternalApi | CustomerApi | ShopApi | FinanceApi | MessageApi | AppApi | DatabaseApi | PrintApi | ShipmentApi | CdnService | CtrlService
export type ServiceTypeDict = { [key in ServiceType]: key }
